module.exports = __webpack_public_path__ + "fonts/montserrat-semibold.fa8441f.ttf";